import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

export default function InputError({
  message,
  className = "",
  ...props
}: HTMLAttributes<HTMLParagraphElement> & { message?: string | string[] }) {
  const content = Array.isArray(message) ? message.join(", ") : message;

  return content ? (
    <p
      {...props}
      className={cn(
        "text-sm text-destructive dark:text-destructive/40",
        className,
      )}
    >
      {content}
    </p>
  ) : null;
}
